import { Col, Form, Select } from "antd";
import { SALES_CONTRACT_COMMERCIAL_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const BgmeaUdExportPermissionCostFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [salesContracts, setSalesContracts] = useState([]);
  const [loading, setLoading] = useState(false);

  const getSalesContracts = async (filter) => {
    setLoading(true);
    const body = {
      page: 1,
      per_page: 100,
      ...(filter?.reference_no && { reference_no: filter.reference_no }),
    };
    const response = await getData(
      `${SALES_CONTRACT_COMMERCIAL_LIST}`,
      null,
      body,
    );
    if (response?.status === 200) {
      setSalesContracts(response?.data?.data?.data || []);
    }
    setLoading(false);
  };

  // on search sales contracts
  const onSalesContractSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await getSalesContracts({ reference_no: value });
    } else if (!value) {
      await getSalesContracts();
    }
  }, []);

  useEffect(() => {
    getSalesContracts();
  }, []);

  return (
    <>
      <Col span={6}>
        <Form.Item label="Sales Contract No" name="sales_contract_id">
          <Select
            size="small"
            placeholder="Select Sales Contract"
            loading={loading}
            showSearch
            optionFilterProp="children"
            onSearch={onSalesContractSearch}
            allowClear
            filterOption={false}
          >
            {salesContracts.map((contract) => (
              <Option
                key={contract.sale_contract_info.id}
                value={contract.sale_contract_info.id}
              >
                {contract.sale_contract_info?.reference_no}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default BgmeaUdExportPermissionCostFilterFields;
